import React from 'react';
import ReportEditor from './ReportEditor';
import Layout from '../common/Layout';
import reportService from '../../services/reportService';

export default ({match: {params: {reportId}}}) => {
    return <Layout>
        <ReportEditor reportService={reportService} reportId={reportId}/>
    </Layout>
};